var searchBreadcrumbs = {
		init: function () {
			this.bindUIActions();
		},
		bindUIActions: function () {
            $(document).on('facetwp-loaded', function () {
        
            	// Add breadcrumbs based on selected filters
				var searchFacets = FWP.facets;
				$('.block.search-results ul.search-breadcrumbs .search-breadcrumb').remove();
				
				$.each(searchFacets, function (index, value) {

					if (index == 'pagination' || index == 'paged') {
						// do nothing
					} else if (index == 'content_types') {
						if (FWP.facets[index].length > 0) {
							value = value[0].replaceAll('-', ' ').replaceAll('_', '/');
                            $('.block.search-results ul.search-breadcrumbs').append('<li class="search-breadcrumb">' + value + '</li>');
						}
					} else if (index == 'locations') {
						if (FWP.facets[index].length > 0) {
							value = value[0].replaceAll('-', ' ');
							$('.block.search-results ul.search-breadcrumbs').append('<li class="search-breadcrumb">' + value + '</li>');
						}
					} else if (index == 'now_picking' || index == 'now_playing' || index == 'open' || index == 'dates' || index == 'date_published' || index == 'meals' || index == 'ingredients') {
						if (FWP.facets[index].length > 0) {
                                                
                            // find labels based on facet name
                            var thisIndex = index;
                            var thisLabel;
                            $.each(FWP.settings.labels, function(index, label) {
                                if (index == thisIndex) {
                                    thisLabel = label;
                                }
                            })
                            
							$('.block.search-results ul.search-breadcrumbs').append('<li class="search-breadcrumb">' + thisLabel + '<button data-filter="' + index + '" class="remove-breadcrumb"><i class="fal fa-times" aria-hidden="true"></i></button></li>');
						}
					} else {
						if (FWP.facets[index].length > 0) {
							searchBreadcrumbs.buildSearchCrumbs(index, value);
						}
					}
				});
            });

            // Remove search breadcrumbs
			$(document).on('click', '.remove-breadcrumb', function(evt) {
				evt.preventDefault();
				var facetValue = $(this).data('filter');
				FWP.reset(facetValue);
			});
        },
		buildSearchCrumbs: function (title, choice) {

			if (title != 'search_field') {
				choice = choice[0].replaceAll('-', ' ');
			}

			$('.block.search-results ul.search-breadcrumbs').append('<li class="search-breadcrumb">' + choice + '<button data-filter="' + title + '" class="remove-breadcrumb"><i class="fal fa-times" aria-hidden="true"></i></button></li>');
		}
    }

module.exports = searchBreadcrumbs;
// test